import type { LoadingManager, WebGLRenderer } from '@seddi/three';
import type { RecolorContext } from '@seddi/ui-recolor';
import log from 'loglevel';

import { load } from './fabricLoader';
import type { FabricWithColor, FabricGfx } from './fabricTypes';
import { ResourceManager } from './resourceManager';

export class FabricsContext extends ResourceManager<FabricGfx> {
  readonly manager: LoadingManager;
  readonly recolor: RecolorContext;
  readonly renderer: WebGLRenderer;

  constructor(manager: LoadingManager, recolor: RecolorContext, renderer: WebGLRenderer) {
    super();
    this.manager = manager;
    this.recolor = recolor;
    this.renderer = renderer;
  }

  async loadAsync(desc: FabricWithColor): Promise<FabricGfx | undefined> {
    if (this.find(desc.id)) {
      log.warn(`FabricsContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const fabric = await load(desc, this.manager, this.renderer, desc.recolorTarget, this.recolor);
    item.status = 'ready';
    item.value = fabric;

    if (this.onLoad) {
      this.onLoad(desc.id, 'Fabric');
    }

    return fabric;
  }
}
